import { Button, AlertDialog, AlertDialogOverlay, AlertDialogContent, AlertDialogHeader, AlertDialogBody, AlertDialogFooter, Spinner, HStack, Text } from '@chakra-ui/react'
import React from 'react'
import { ErrorMessage } from '../components/ErrorMessage';
import { useOperation } from '../components/useOperation';

export const DeleteConfirmationDialog = (props: {
  title: string;
  description: string;

  data: any;
  onClose: () => void;
  onDelete: (data: any) => Promise<any>;
}) => {

  const [onDelete, errorMessage, isProcessing] = useOperation(async () => {
    await props.onDelete(props.data);
    props.onClose();
  }, [props.data]);

  const cancelRef = React.useRef<any>()

  return (
    <AlertDialog
      isOpen
      leastDestructiveRef={cancelRef}
      onClose={props.onClose}
      isCentered
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize='lg' fontWeight='bold'>
            {props.title}
          </AlertDialogHeader>

          <AlertDialogBody>
            <ErrorMessage error={errorMessage} />
            {props.description}
          </AlertDialogBody>

          <AlertDialogFooter>
            <Button colorScheme='red' onClick={onDelete} isDisabled={isProcessing} mr={3}>
              <HStack spacing={2}>{isProcessing && <Spinner />}<Text>Delete</Text></HStack>
            </Button>
            <Button ref={cancelRef} variant='outline' onClick={props.onClose}>
              Cancel
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  )
}